import Grid from '@mui/material/Grid';
import React from 'react';
import { useAuth } from 'components/Authentication/AuthenticationProvider';
import AccountWidget from './AccountWidget';

export const NavBar = () => {
  const { username: loggedIn } = useAuth();

  return (
    <Grid
      container
      sx={(theme) => ({
        justifyContent: 'space-between',
        alignItems: 'center',
        '> * + *': { marginLeft: theme.spacing(4) },
      })}
    >
      <span />
      {loggedIn ? <AccountWidget /> : null}
    </Grid>
  );
};
